// Copyright 1999-2026. WebPros International GmbH. All rights reserved.

import pageData from '../helpers/pageData';

export default () => {
    pageData({ ...pageData(), status: [] });

    const contentElement = document.getElementById('main');
    if (!contentElement) {
        return;
    }
    ['.msg-error', '.msg-info', '.msg-warning'].forEach(msgClass => {
        contentElement.querySelectorAll(`${msgClass}:not([data-rendered-by-react])`).forEach(messageElement => {
            messageElement.parentNode.removeChild(messageElement);
        });
    });
};
